// src/ui/shell/DemoStrip.tsx (T1): the demo's bar when site.demo (spec 2.10): the chapter bar that guides the demo
// tour (src/demo/DemoBar.tsx, docs/DECISIONS.md "Demo tour"). Inside a shell it sits at the top of the main column,
// so the full-height sidebar keeps its account row on screen; App shows it above screens that have no shell
// (sign-in, demo, Start Your Build, not found).
import { signal } from "@preact/signals";
import { useLayoutEffect } from "preact/hooks";
import { DemoBar } from "../../demo/DemoBar";

const mountedShells = signal(0);

/** Called by each shell: while one is mounted, App's own strip steps aside. */
export function useShellMounted(): void {
  useLayoutEffect(() => {
    mountedShells.value += 1;
    return () => {
      mountedShells.value -= 1;
    };
  }, []);
}

export function DemoStrip() {
  return <DemoBar />;
}

/** App's strip, for screens outside the shells. */
export function DemoBanner() {
  if (mountedShells.value > 0) return null;
  return <DemoStrip />;
}
